import { ITransportDetailSection } from 'types/transport'
import DetailInfoArea from 'components/transport/DetailInfoArea';
import Loading from 'components/common/Loading';

const CargoInCargoInfo = ({ detailInfo, loading }: ITransportDetailSection) => {

    if (loading) return <div className='flex justify-center items-center h-96'><Loading /></div>

    return (
        <div className='bg-white border-[#9D9EB7] border-1 rounded-lg'>
            <div className='bg-[#F8F8FA] px-10 py-6 rounded-t-lg'>
                <p className='font-semibold text-2xl'>차량정보</p>
            </div>
            <div className='flex flex-col gap-3 px-10 py-6'>
                {
                    detailInfo?.cargoInfo?.length > 0 &&
                    detailInfo?.cargoInfo.map((item, idx) => (
                        <div className='relative flex flex-col justify-start items-start gap-6 px-10 py-6 border border-[#9D9EB7] rounded text-lg' key={idx}>
                            <DetailInfoArea
                                title='차량번호'
                                value={item.carNumber}
                            />
                            <DetailInfoArea
                                title='기사연락처'
                                value={item.driverPhone}
                            />
                            <DetailInfoArea
                                title='담당기사'
                                value={item.driverName}
                            />
                            <DetailInfoArea
                                title='컨테이너'
                                value={`${item.containerNumber} | ${item.containerType}`}
                            />
                        </div>
                    ))
                }
            </div>
        </div>
    )
}

export default CargoInCargoInfo